// Theme
export const THEME_SET = "THEME_SET";
export const THEMES = {
  DEFAULT: "DEFAULT",
  DARK: "DARK",
  LIGHT: "LIGHT",
  BLUE: "BLUE",
  GREEN: "GREEN",
  INDIGO: "INDIGO",
};

// Auth
export const AUTH_SIGN_IN_REQUEST = "AUTH_SIGN_IN_REQUEST";
export const AUTH_SIGN_IN_SUCCESS = "AUTH_SIGN_IN_SUCCESS";
export const AUTH_SIGN_IN_FAILURE = "AUTH_SIGN_IN_FAILURE";
export const AUTH_SIGN_OUT = "AUTH_SIGN_OUT";
export const AUTH_SIGN_UP_REQUEST = "AUTH_SIGN_UP_REQUEST";
export const AUTH_SIGN_UP_SUCCESS = "AUTH_SIGN_UP_SUCCESS";
export const AUTH_SIGN_UP_FAILURE = "AUTH_SIGN_UP_FAILURE";
export const AUTH_RESET_PASSWORD_REQUEST = "AUTH_RESET_PASSWORD_REQUEST";
export const AUTH_RESET_PASSWORD_SUCCESS = "AUTH_RESET_PASSWORD_SUCCESS";
export const AUTH_RESET_PASSWORD_FAILURE = "AUTH_RESET_PASSWORD_FAILURE";

//User
export const USER_FETCH = "USER_FETCH";
export const USER_UPDATE = "USER_UPDATE";
export const USER_ERROR = "USER_ERROR";
export const CLEAR_USER_ERROR = "CLEAR_USER_ERROR";

//Companies
export const COMPANY_FETCH = "COMPANY_FETCH";
export const COMPANY_BY_PROPERTY_FETCH = "COMPANY_BY_PROPERTY_FETCH";
export const CLEAR_COMPANY = "CLEAR_COMPANY"
export const CLEAR_COMPANY_BY_PROPERTY = "CLEAR_COMPANY_BY_PROPERTY"
export const COMPANYOPTIONS_FETCH = "COMPANYOPTIONS_FETCH";
export const COMPANY_UPDATE = "COMPANY_UPDATE";
export const COMPANY_BY_PROPERTY_UPDATE = "COMPANY_BY_PROPERTY_UPDATE";
export const COMPANY_ERROR = "COMPANY_ERROR";
export const CLEAR_COMPANY_ERROR = "CLEAR_COMPANY_ERROR";
export const FETCH_COMPANIES = "FETCH_COMPANIES"
export const FETCH_PAGED_COMPANIES = "FETCH_PAGED_COMPANIES"
export const CLEAR_PAGED_COMPANIES = "CLEAR_PAGED_COMPANIES"
export const SET_COMPANY_COUNT = "SET_COMPANY_COUNT"


//Property
export const PROPERTY_CREATE = "PROPERTY_CREATE";
export const PROPERTY_UPDATE = "PROPERTY_UPDATE";
export const PARTIAL_PROPERTY_UPDATE = "PARTIAL_PROPERTY_UPDATE";
export const FETCH_PROPERTIES = "FETCH_PROPERTIES"
export const FETCH_PROPERTY = "FETCH_PROPERTY"
export const SET_PROPERTY_COUNT = "SET_PROPERTY_COUNT"
export const CLEAR_PROPERTY = "CLEAR_PROPERTY"
export const CLEAR_PROPERTIES = "CLEAR_PROPERTIES"
export const GET_ACCESSIBILITY_UNIT_TYPES = "GET_ACCESSIBILITY_UNIT_TYPES"
export const FETCH_TOTAL_ACCESSIBILITY_PROGRESS_BAR = "FETCH_TOTAL_ACCESSIBILITY_PROGRESS_BAR"
export const CLEAR_TOTAL_ACCESSIBILITY_PROGRESS_BAR = "CLEAR_TOTAL_ACCESSIBILITY_PROGRESS_BAR"
export const LOADING_PROPERTIES = "LOADING_PROPERTIES"
export const LOADING_PROPERTY = "LOADING_PROPERTY"

// Property accessibility infos
export const FETCH_PROPERTY_ACCESSIBILITY_INFOS = "FETCH_PROPERTY_ACCESSIBILITY_INFOS"
export const UPDATE_PROPERTY_ACCESSIBILITY_INFOS = "UPDATE_PROPERTY_ACCESSIBILITY_INFOS"
export const CREATE_PROPERTY_ACCESSIBILITY_INFOS = "CREATE_PROPERTY_ACCESSIBILITY_INFOS"
export const CLEAR_PROPERTY_ACCESSIBILITY_INFOS = "CLEAR_PROPERTY_ACCESSIBILITY_INFOS"

// Property free text infos
export const FETCH_PROPERTY_FREE_TEXT_INFOS = "FETCH_PROPERTY_FREE_TEXT_INFOS"
export const CREATE_PROPERTY_FREE_TEXT_INFOS = "CREATE_PROPERTY_FREE_TEXT_INFOS"
export const UPDATE_PROPERTY_FREE_TEXT_INFOS = "UPDATE_PROPERTY_FREE_TEXT_INFOS"
export const DELETE_PROPERTY_FREE_TEXT_INFOS = "DELETE_PROPERTY_FREE_TEXT_INFOS"
export const CLEAR_PROPERTY_FREE_TEXT_INFOS = "CLEAR_PROPERTY_FREE_TEXT_INFOS"


//Facilities
export const SET_FACILITIES = "SET_FACILITIES";
export const GET_FACILITIES = "GET_FACILITIES";

//Questions
export const FETCH_QUESTIONS = 'FETCH_QUESTIONS'


//Units

export const FETCH_UNITS = "FETCH_UNITS";
export const CLEAR_UNITS = "CLEAR_UNITS";
export const CREATE_UNIT = "CREATE_UNIT";
export const UPDATE_UNIT = "UPDATE_UNIT";
export const DELETE_UNIT = "DELETE_UNIT";
export const FETCH_ACCESSIBILITY_UNITS_COUNTS = "FETCH_ACCESSIBILITY_UNITS_COUNTS"
export const CLEAR_ACCESSIBILITY_UNITS_COUNTS = "CLEAR_ACCESSIBILITY_UNITS_COUNTS"

//Units level

export const FETCH_UNIT_LEVELS = "FETCH_UNIT_LEVELS";
export const CREATE_UNIT_LEVELS = "CREATE_UNIT_LEVELS";
export const UPDATE_UNIT_LEVELS = "UPDATE_UNIT_LEVELS";
export const DELETE_UNIT_LEVELS = "DELETE_UNIT_LEVELS";

//A11yes

export const FETCH_A11YES = "FETCH_A11YES"
export const CLEAR_A11YES = "CLEAR_A11YES"
export const CREATE_A11Y = "CREATE_A11Y"
export const DELETE_A11Y = "DELETE_A11Y"
export const UPDATE_A11Y = "UPDATE_A11Y"
export const FETCH_COUNTS_DISABILITY_TYPES = "FETCH_COUNTS_DISABILITY_TYPES"
export const CLEAR_COUNTS_DISABILITY_TYPES = "CLEAR_COUNTS_DISABILITY_TYPES"
export const FETCH_A11YES_BY_PROPERTY = "FETCH_A11YES_BY_PROPERTY"
export const CLEAR_A11YES_BY_PROPERTY = "CLEAR_A11YES_BY_PROPERTY"

//Unit images

export const FETCH_UNIT_IMAGES = "FETCH_UNIT_IMAGES"
export const FETCH_UNIT_IMAGES_BY_PROPERTY = "FETCH_UNIT_IMAGES_BY_PROPERTY"
export const FETCH_UNIT_IMAGES_BY_COMPANY_ID = "FETCH_UNIT_IMAGES_BY_COMPANY_ID"
export const FETCH_COUNT_UNIT_IMAGES = "FETCH_COUNT_UNIT_IMAGES"
export const UPDATE_UNIT_IMAGE_BY_PROPERTY = "UPDATE_UNIT_IMAGE_BY_PROPERTY"
export const CLEAR_COUNT_UNIT_IMAGES = "CLEAR_COUNT_UNIT_IMAGES"
export const CLEAR_UNIT_IMAGES = "CLEAR_UNIT_IMAGES"
export const CLEAR_UNIT_IMAGES_BY_COMPANY_ID = "CLEAR_UNIT_IMAGES_BY_COMPANY_ID"
export const LOADING_UNIT_IMAGES = "LOADING_UNIT_IMAGES"
export const UPDATE_UNIT_IMAGE = "UPDATE_UNIT_IMAGE"
export const PARTIAL_UPDATE_UNIT_IMAGE = "PARTIAL_UPDATE_UNIT_IMAGE"
export const DELETE_UNIT_IMAGE = "DELETE_UNIT_IMAGE"
export const DELETE_UNIT_IMAGE_BY_COMPANY_ID = "DELETE_UNIT_IMAGE_BY_COMPANY_ID"
export const DELETE_UNIT_IMAGE_BY_PROPERTY = "DELETE_UNIT_IMAGE_BY_PROPERTY"

//a11yStandard

export const FETCH_A11YSTANDARD = "FETCH_A11YSTANDARD"
export const FETCH_A11YSTANDARD_LOADING = "FETCH_A11YSTANDARD_LOADING"

//Contracts

export const FETCH_CONTRACT = 'FETCH_CONTRACT'
export const CLEAR_CONTRACT = 'CLEAR_CONTRACT'

//Services

export const FETCH_OPENED_THE_ACCESSIBILITY = 'FETCH_OPENED_THE_ACCESSIBILITY'
export const FETCH_INTERACTION_WITH_THE_ACC = 'FETCH_INTERACTION_WITH_THE_ACC'
export const FETCH_ACTION_PER_VISITOR = 'FETCH_ACTION_PER_VISITOR'
export const CLEAR_MIXPANEL_DATA = 'CLEAR_MIXPANEL_DATA'

//Toasts

export const ADD_TOAST = 'ADD_TOAST'
export const REMOVE_TOAST = 'REMOVE_TOAST'
export const REMOVE_TOASTS = 'REMOVE_TOASTS'

